// extracted by mini-css-extract-plugin
export var active = "desktopNav-module--active--62622";
export var desktop = "desktopNav-module--desktop--bae57";
export var letsTalkCta = "desktopNav-module--letsTalkCta--e0fbd";
export var loginCta = "desktopNav-module--loginCta--f36a7";
export var logoWrap = "desktopNav-module--logoWrap--cfb07";
export var nav = "desktopNav-module--nav--47373";
export var navCta = "desktopNav-module--navCta--8826e";
export var navLinks = "desktopNav-module--navLinks--f97f2";
export var patented = "desktopNav-module--patented--fdc3a";
export var theme_dark = "desktopNav-module--theme_dark--579d3";
export var theme_light = "desktopNav-module--theme_light--095d7";